
import InvoiceButton from '@/components/Invoice/Button/index.vue'
import { isValid } from '@/classes/ChekType.ts'
import { defineComponent, reactive, watch } from 'vue'
export default defineComponent({
  components: { InvoiceButton },
  emits: ['close', 'login', 'wallet'],
  name: 'InvoicePopup',
  props: {
    modelValue: {
      type: Boolean,
      default: () => {
        return {
          title: null,
          message: null,
          type: null,
          isLogin: false,
          isWallet: false,
          isClose: false,
          isColorClose: false
        }
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const { emit } = context
    const { modelValue } = props
    watch(
      () => props.modelValue,
      val => {}
    )
    return {
      modelValue,
      close,
      emit,
      isValid
    }
  }
})
